var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',_vm._l((_vm.videos.items),function(gallery,index){return _c('b-col',{key:index,staticClass:"col-md-4 col-sm-4 col-12"},[_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":'https://www.youtube.com/embed/' +
            gallery.contentDetails.videoId,"allowfullscreen":""}}),_c('p',{staticClass:"galleryTitle"},[_vm._v(" "+_vm._s(gallery.snippet.title)+" ")])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }